// src/Es.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Es_default = createIcon({
  displayName: "Es",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        id: "yellow",
        x: "1.5",
        y: "1",
        width: "48",
        height: "32",
        fill: "#FBB43A"
      }),
      /* @__PURE__ */ jsx("rect", {
        id: "red",
        x: "1.5",
        y: "1",
        width: "48",
        height: "8",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("rect", {
        id: "red_2",
        x: "1.5",
        y: "25",
        width: "48",
        height: "8",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsxs("g", {
        id: "emblem",
        children: [
          /* @__PURE__ */ jsx("path", {
            id: "Rectangle 77",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.5 13.5V23H9V24H6V23H6.5V13.5H8.5Z",
            fill: "#DEE8F0"
          }),
          /* @__PURE__ */ jsx("ellipse", {
            id: "Oval 64",
            cx: "7.5",
            cy: "13.5",
            rx: "1",
            ry: "0.5",
            fill: "#FF1A26"
          }),
          /* @__PURE__ */ jsxs("g", {
            id: "Group 26",
            children: [
              /* @__PURE__ */ jsx("path", {
                id: "Rectangle 78",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.45837 13.4106H19.5417V20.5297C19.5417 22.987 17.2845 24.0892 14.5 24.0892C11.7156 24.0892 9.45837 22.987 9.45837 20.5297V13.4106Z",
                fill: "#DEE8F0"
              }),
              /* @__PURE__ */ jsx("rect", {
                id: "Rectangle 79",
                x: "9.91675",
                y: "13.8213",
                width: "4.58333",
                height: "4.10714",
                fill: "#FF1A26"
              }),
              /* @__PURE__ */ jsx("path", {
                id: "Rectangle 79_2",
                d: "M9.91675 17.9285H14.5001V20.5654C14.5001 21.831 13.4741 22.857 12.2084 22.857C10.9428 22.857 9.91675 21.831 9.91675 20.5654V17.9285Z",
                fill: "#FBB43A"
              }),
              /* @__PURE__ */ jsx("path", {
                id: "Rectangle 79_3",
                d: "M14.5 17.9285H19.0833V20.5654C19.0833 21.831 18.0573 22.857 16.7917 22.857C15.526 22.857 14.5 21.831 14.5 20.5654V17.9285Z",
                fill: "#FF1A26"
              }),
              /* @__PURE__ */ jsx("ellipse", {
                id: "Oval 64_2",
                cx: "16.7917",
                cy: "15.875",
                rx: "1.375",
                ry: "1.64286",
                fill: "#FF1A26"
              })
            ]
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Rectangle 77_2",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.5 13.5V23H23V24H20V23H20.5V13.5H22.5Z",
            fill: "#DEE8F0"
          }),
          /* @__PURE__ */ jsx("ellipse", {
            id: "Oval 64_3",
            cx: "21.5",
            cy: "13.5",
            rx: "1",
            ry: "0.5",
            fill: "#FF1A26"
          }),
          /* @__PURE__ */ jsx("ellipse", {
            id: "Oval 64_4",
            cx: "14.5",
            cy: "11.5",
            rx: "4",
            ry: "1.5",
            fill: "#FF1A26"
          })
        ]
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      })
    ]
  })
});

export {
  Es_default
};
